import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const roleParam = searchParams.get('role') || '';

  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const getRoleInfo = () => {
    switch (roleParam) {
      case 'admin':
        return { title: 'Admin Login', subtitle: 'Access the Admin Dashboard', icon: 'fa-user-shield', color: '#8b0000' };
      case 'faculty':
        return { title: 'Faculty Login', subtitle: 'Access the Faculty Portal', icon: 'fa-chalkboard-teacher', color: '#22c55e' };
      case 'student':
        return { title: 'Student Login', subtitle: 'Access the Student Portal', icon: 'fa-user-graduate', color: '#3b82f6' };
      default:
        return { title: 'Welcome Back', subtitle: 'Sign in to continue', icon: 'fa-sign-in-alt', color: '#8b0000' };
    }
  };

  const roleInfo = getRoleInfo();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await authAPI.loginJson(formData.email, formData.password);
      localStorage.setItem('token', response.access_token);
      localStorage.setItem('user', JSON.stringify({ id: response.user_id, role: response.role }));
      switch (response.role) {
        case 'admin': navigate('/admin'); break;
        case 'faculty': navigate('/faculty'); break;
        case 'student': navigate('/student'); break;
        default: navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-left">
          <div className="login-branding">
            <div className="login-logo">{'🎓'}</div>
            <h1>MTC School</h1>
            <p>Student Management System</p>
          </div>
          <div className="login-features">
            <div className="login-feature-item"><i className="fas fa-user-graduate"></i><span>Student Portal</span></div>
            <div className="login-feature-item"><i className="fas fa-chalkboard-teacher"></i><span>Faculty Access</span></div>
            <div className="login-feature-item"><i className="fas fa-user-shield"></i><span>Admin Dashboard</span></div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-form-container">
            <div className="login-role-header" style={{ borderColor: roleInfo.color }}>
              <i className={`fas ${roleInfo.icon}`} style={{ color: roleInfo.color }}></i>
              <h2>{roleInfo.title}</h2>
            </div>
            <p className="login-subtitle">{roleInfo.subtitle}</p>

            {error && (
              <div className="error-message">
                <i className="fas fa-exclamation-circle"></i> {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email"><i className="fas fa-envelope"></i> Email Address</label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required />
              </div>
              <div className="form-group">
                <label htmlFor="password"><i className="fas fa-lock"></i> Password</label>
                <input type="password" id="password" name="password" value={formData.password} onChange={handleChange} placeholder="Enter your password" required />
              </div>
              <div className="form-options">
                <label className="remember-me"><input type="checkbox" /><span>Remember me</span></label>
                <a href="#forgot" className="forgot-link">Forgot Password?</a>
              </div>
              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? (<><i className="fas fa-spinner fa-spin"></i> Signing in...</>) : (<><i className="fas fa-sign-in-alt"></i> Sign In</>)}
              </button>
            </form>

            <div className="role-switch">
              <p>Login as:</p>
              <div className="role-links">
                <Link to="/login?role=admin" className={`role-link admin ${roleParam === 'admin' ? 'active' : ''}`}><i className="fas fa-user-shield"></i> Admin</Link>
                <Link to="/login?role=faculty" className={`role-link faculty ${roleParam === 'faculty' ? 'active' : ''}`}><i className="fas fa-chalkboard-teacher"></i> Faculty</Link>
                <Link to="/login?role=student" className={`role-link student ${roleParam === 'student' ? 'active' : ''}`}><i className="fas fa-user-graduate"></i> Student</Link>
              </div>
            </div>

            <Link to="/" className="back-home"><i className="fas fa-arrow-left"></i> Back to Homepage</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
